import studentCenter from '@/views/Warrant/studentCenter/index.vue'
import productCenter from '@/views/Warrant/productCenter/index.vue'
import orderCenter from '@/views/Warrant/orderCenter/index.vue'
import writeoffCenter from '@/views/Warrant/writeoffCenter/index.vue'

export default [
  {
    path: '/Warrant/studentCenter',
    component: studentCenter,
    meta: { title: '学员中心' }
  },
  {
    path: '/Warrant/productCenter/',
    component: productCenter,
    meta: { title: '产品中心' }
  },
  {
    path: '/Warrant/orderCenter',
    component: orderCenter,
    meta: { title: '订单中心' }
  },
  {
    path: '/Warrant/writeoffCenter',
    component: writeoffCenter,
    meta: { title: '核销中心' }
  },
]